import React from 'react';

import { Box, CssBaseline, Grid } from '@material-ui/core';

import { COLORS } from 'theme/constants';
import useIsMobile from 'hooks/useIsMobile';

import { GlobalStyle, PageWrapper, Root, CozmosLogoLight, Title, MobileBackground } from './style';

interface BuilderLayoutProps {
  children: React.ReactNode;
}

function renderDesktop(children: React.ReactNode) {
  return (
    <PageWrapper>
      <Root>
        <CssBaseline />
        <GlobalStyle />
        <Grid container spacing={6}>
          <Grid item sm={5} style={{ maxWidth: '850px' }}>
            {children}
          </Grid>
          <Grid item sm={7} style={{ display: 'flex', position: 'relative', paddingLeft: '1.88%' }}>
            <Box py="8%" display="flex" flexDirection="column" justifyContent="space-between">
              <a href="https://cozmos.world"><CozmosLogoLight /></a>
              <Title>
                A <span style={{ color: COLORS.cozmosPink }}>link in bio</span> for
                <br /> creators who live
                <br /> outside the box
              </Title>
            </Box>
          </Grid>
        </Grid>
      </Root>
    </PageWrapper>
  );
}

function renderMobile(children: React.ReactNode) {
  return <MobileBackground>{children}</MobileBackground>;
}

function BuilderLayout({ children }: BuilderLayoutProps) {
  const isMobile = useIsMobile();
  if (!React.Children.count(children)) return null;
  if (isMobile) return renderMobile(children);
  return renderDesktop(children);
}

export default BuilderLayout;
